import React from 'react';
import TimeUtil from 'time';
import StartTimeMixin from 'main/components/show/cuesheet/startTimeMixin';
import PureRenderMixin from 'react-addons-pure-render-mixin';

/**
 * Featured Start Time component
 */
export default React.createClass({
  displayName: 'FeaturedStartTime',

  mixins: [StartTimeMixin, PureRenderMixin],

  propTypes: {
    item: React.PropTypes.object.isRequired,
    rowIndex: React.PropTypes.number.isRequired,
    twentyFourHourClock: React.PropTypes.bool.isRequired,
    timeZone: React.PropTypes.string.isRequired,
    showStartOn: React.PropTypes.number, //Used by the StartTimeMixin
  },

  render() {
    let { twentyFourHourClock } = this.props;

    return (
      <div className="featured-start-time">
        {TimeUtil.getShorthandTimeUTC(
          this._getStartTimeValue(),
          twentyFourHourClock,
        )}
      </div>
    );
  },
});
